import {
  EDIT_LAST_NAME_FIND_USER, RESET_FIND_USER_INPUT,
  FIND_USER_SUCCESS, FIND_USER_FAILED
} from "../actions/find_user_actions";


const initialState = {
  last_name: '',
};

export const findUserReducerForm = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_LAST_NAME_FIND_USER: {
      return {
        ...state,
        last_name: action.last_name
      }
    }
    case RESET_FIND_USER_INPUT: {
      return {
        ...state,
        last_name: '',
      }
    }
    default: return state;
  }
}
